import type {ReactElement, SyntheticEvent} from 'react';
import {useRef} from 'react';
import {getAssetUrl} from '@Utils/s3.util';
import {noop} from '@Utils/general.util';
import styles from './ai-chat-assets-video-illustration.module.scss';
import {
  VIDEO_ILLUSTRATION_BASKETBALL_PATH,
  VIDEO_ILLUSTRATION_DISCO_PATH,
  VIDEO_ILLUSTRATION_PIZZA_PATH,
  VIDEO_ILLUSTRATION_PLAY_COUNT,
} from './ai-chat-assets-video-illustration.types';

export function AiChatAssetsVideoIllustration(): ReactElement {
  const playCountsRef = useRef(new Map<HTMLVideoElement, number>());

  /** Each clip counts its own passes, so no cross-video coordination is needed to stop them together. */
  const replayUntilPlayCountReached = (event: SyntheticEvent<HTMLVideoElement>): void => {
    const video = event.currentTarget;
    const timesPlayed = (playCountsRef.current.get(video) ?? 0) + 1;
    playCountsRef.current.set(video, timesPlayed);

    if (timesPlayed >= VIDEO_ILLUSTRATION_PLAY_COUNT) {
      return;
    }

    video.currentTime = 0;
    void video.play().catch(noop);
  };

  const renderCard = (assetPath: string, cardClass: string): ReactElement => {
    return (
      <div className={`${styles.card} ${cardClass}`}>
        <video aria-hidden="true" autoPlay className={styles.cardVideo} muted onEnded={replayUntilPlayCountReached} playsInline preload="auto" src={getAssetUrl(assetPath)} />
      </div>
    );
  };

  return (
    <div className={styles.illustration}>
      {renderCard(VIDEO_ILLUSTRATION_DISCO_PATH, styles.cardDisco)}
      {renderCard(VIDEO_ILLUSTRATION_BASKETBALL_PATH, styles.cardBasketball)}
      {renderCard(VIDEO_ILLUSTRATION_PIZZA_PATH, styles.cardPizza)}
    </div>
  );
}
